export default __webpack_public_path__ + "static/media/apple.f83e8df2.svg";